import {
  ProgressNotifier,
  ProgressNotifierCallbacks,
} from './ProgressNotifier';
import {
  Translations,
  TranslationUnit,
} from '../assets/translations/Translations';
import { ClientContext } from './ClientContextFactory';
import { Alpha2CountryCode, CardNetwork, SupportedLocale } from '../types';
import { Analytics } from '../analytics/Analytics';
import { IOptionStoreListener } from '../store/OptionStore';

interface AuxillaryOptions {
  countryCode: Alpha2CountryCode;
  allowedCardNetworks?: CardNetwork[];
  optionStore: IOptionStoreListener;
}

export interface PaymentMethodContextOptions
  extends ProgressNotifierCallbacks,
    AuxillaryOptions {
  locale: SupportedLocale;
}

export interface IPaymentMethodContext extends ClientContext, AuxillaryOptions {
  progress: ProgressNotifier;
  translations: TranslationUnit;
  analytics: Analytics;
}

export const PaymentMethodContext = {
  create(
    clientContext: ClientContext,
    options: PaymentMethodContextOptions,
    optionStore: IOptionStoreListener,
  ): IPaymentMethodContext {
    return {
      ...clientContext,
      /**
       * deprecated
       */
      countryCode: options.countryCode,
      //
      allowedCardNetworks: options.allowedCardNetworks,
      progress: new ProgressNotifier({
        onTokenizeStart: options.onTokenizeStart,
        onTokenizeEnd: options.onTokenizeEnd,
        onTokenizeProgress: options.onTokenizeProgress,
        onTokenizeError: options.onTokenizeError,
        onTokenizeSuccess: options.onTokenizeSuccess,
      }),
      translations: Translations.get(options.locale),
      optionStore,
    };
  },
};

export default PaymentMethodContext;
